import {
  FetchRenderGenerationResponse,
  RenderGenerationStatus
} from '../../../renderGenerations/renderGenerationsTypes';
import type { GenerationPollResult } from '../../../modelViewers/components/content/ModelViewerEditor/hooks/useModelViewerLifestyleGeneration/useGenerationPolling/useGenerationPolling';

function mapCompositeRenderPollResponse(
  data: FetchRenderGenerationResponse
): GenerationPollResult<RenderGenerationStatus> {
  const result = data.results[0];

  if (data.status === RenderGenerationStatus.Completed) {
    return {
      status: RenderGenerationStatus.Completed,
      resultPreviewUrl: result?.image_result,
      resultFullUrl: result?.image_result,
      isSuccess: true
    };
  }

  if (
    data.status === RenderGenerationStatus.Failed ||
    data.status === RenderGenerationStatus.Cancelled
  ) {
    return {
      status: RenderGenerationStatus.Failed,
      errorMessage: data.error_message ?? result?.error_message ?? undefined,
      isFailed: true
    };
  }

  return { status: data.status };
}

export default mapCompositeRenderPollResponse;
